/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2LogsIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2LogsIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2LogsIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 15,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2LogsIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 15 14"
 style={{'--as-1-1APy0': alignSelf,'--mt-2-1APy0': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1APy0': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1APy0': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1APy0': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1APy0': opacity,'--w-10-1APy0': typeof width === 'number' ? `${width}px` : width,'--h-11-1APy0': typeof height === 'number' ? `${height}px` : height,'--f-12-1APy0': fill,'--a-7-1APy0': isAnimated ? animation : "none",'--sd-8-1APy0': isAnimated ? strokeDashoffset : 0,'--sd-9-1APy0': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2LogsIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.407 0a1.5 1.5 0 00-1.5 1.5v4.492A4.75 4.75 0 017.618 14h5.79a1.5 1.5 0 001.5-1.5v-8a.5.5 0 00-.147-.354l-4-4A.5.5 0 0010.407 0h-6zm3.5 10.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM5.85 9.058a.625.625 0 010 .884l-1 1a.625.625 0 11-.884-.884l1-1a.625.625 0 01.884 0z"
 style={{'--f-12-1APy0': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}